// import { createSlice } from "@reduxjs/toolkit";
// import {
//   createClaimantCounselAction,
//   updateClaimantCounselAction,
//   deleteClaimantCounselAction,
//   getClaimantCounselByCaseIDAction,
//   deleteClaimantCounselDocumentAction,
// } from "../../actions/ClaimantCounsel/claimantCounselAction";

// const initialState = {
//   claimantCounselList: [],
//   loading: false,
//   error: null,
// };
// const claimantCounselSlice = createSlice({
//   name: "claimantCounsel",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(getClaimantCounselByCaseIDAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(getClaimantCounselByCaseIDAction.fulfilled, (state, action) => {
//         state.loading = false;
//         state.claimantCounselList = action.payload;
//       })
//       .addCase(getClaimantCounselByCaseIDAction.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     builder
//       .addCase(createClaimantCounselAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(createClaimantCounselAction.fulfilled, (state, action) => {
//         state.loading = false;
//         state.claimantCounselList.push(action.payload);
//       })
//       .addCase(createClaimantCounselAction.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     builder
//       .addCase(updateClaimantCounselAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateClaimantCounselAction.fulfilled, (state, action) => {
//         state.loading = false;
//         const index = state.claimantCounselList.findIndex(
//           (item) => item.id === action.payload.id,
//         );
//         if (index !== -1) {
//           state.claimantCounselList[index] = action.payload;
//         }
//       })
//       .addCase(updateClaimantCounselAction.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     builder
//       .addCase(deleteClaimantCounselAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteClaimantCounselAction.fulfilled, (state, action) => {
//         state.loading = false;
//         const index = state.claimantCounselList.findIndex(
//           (item) => item.id === action.payload.id,
//         );
//         if (index !== -1) {
//           state.claimantCounselList.splice(index, 1);
//         }
//       })
//       .addCase(deleteClaimantCounselAction.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     builder
//       .addCase(deleteClaimantCounselDocumentAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteClaimantCounselDocumentAction.fulfilled, (state) => {
//         state.loading = false;
//       })
//       .addCase(
//         deleteClaimantCounselDocumentAction.rejected,
//         (state, action) => {
//           state.loading = false;
//           state.error = action.payload;
//         },
//       );
//   },
// });

// export default claimantCounselSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";
import {
  createClaimantCounselAction,
  updateClaimantCounselAction,
  deleteClaimantCounselAction,
  getClaimantCounselByCaseIDAction,
  deleteClaimantCounselDocumentAction,
} from "../../actions/ClaimantCounsel/claimantCounselAction";

// ============================================================================
// INITIAL STATE
// ============================================================================

const initialState = {
  counsels: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

// ============================================================================
// SLICE
// ============================================================================

const claimantCounselSlice = createSlice({
  name: "claimantCounsel",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    // =========================================================================
    // GET COUNSELS BY CASE ID
    // =========================================================================
    builder
      .addCase(getClaimantCounselByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClaimantCounselByCaseIDAction.fulfilled, (state, action) => {
        state.loading = false;
        state.counsels = action.payload.data || [];
      })
      .addCase(getClaimantCounselByCaseIDAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // CREATE COUNSEL
    // =========================================================================
    builder
      .addCase(createClaimantCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createClaimantCounselAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Counsel created successfully";
        state.counsels.push(action.payload.data);
      })
      .addCase(createClaimantCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // UPDATE COUNSEL
    // =========================================================================
    builder
      .addCase(updateClaimantCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClaimantCounselAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Counsel updated successfully";

        const index = state.counsels.findIndex(
          (c) =>
            c.claimantCounsel_ID === action.payload.data.claimantCounsel_ID,
        );

        if (index !== -1) {
          state.counsels[index] = action.payload.data;
        }
      })
      .addCase(updateClaimantCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE COUNSEL
    // =========================================================================
    builder
      .addCase(deleteClaimantCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClaimantCounselAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Counsel deleted successfully";

        state.counsels = state.counsels.filter(
          (c) => c.claimantCounsel_ID !== action.payload,
        );
      })
      .addCase(deleteClaimantCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE COUNSEL DOCUMENT
    // =========================================================================
    builder
      .addCase(deleteClaimantCounselDocumentAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClaimantCounselDocumentAction.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Document deleted successfully";
      })
      .addCase(
        deleteClaimantCounselDocumentAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );
  },
});

export const { clearError, clearSuccess } = claimantCounselSlice.actions;
export default claimantCounselSlice.reducer;
